<app-capture-history-item-title>
  {{ title }}
</app-capture-history-item-title>
<app-capture-history-item-body>
  <p>
    {{ description }}
  </p>
</app-capture-history-item-body>
